<ng-template #bookingVehicleFilterModal let-modal>
    <div class="offcanvas-header border-bottom">
        <h4 class="modal-title">{{ "heading-title.filter" | translate }}</h4>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="offcanvas-body">
        @if(accessibilityList.length > 0){
        <div class="row mb-4">
            <div class="col-12 mb-3">
                <h5 class="mb-0">{{ "heading-title.accessibility-preference" | translate }}</h5>
            </div>
            @for (accessibility of accessibilityList; track $index) {
            <div class="col-12 mb-2">
                <div class="form-check form-check-secondary mb-0">
                    <input class="form-check-input" type="checkbox" [id]="'accessibility' + accessibility.accessibility"
                        [checked]="accessibility.isChecked" (change)="onChangeAccessibility($event, accessibility)" />
                    <label class="form-check-label" [for]="'accessibility' + accessibility.accessibility">
                        {{ accessibility.accessibility }}
                    </label>
                </div>
            </div>
            }
        </div>
        }
        @if (countrySetting?.speakingLanguages?.length > 0) {
        <div class="row mb-4">
            <div class="col-12 mb-3">
                <h5 class="mb-0">{{ "heading-title.select-language" | translate }}</h5>
            </div>
            @for (language of countrySetting.speakingLanguages; track $index) {
            <div class="col-12 mb-2">
                <div class="form-check form-check-secondary mb-0">
                    <input class="form-check-input" type="radio" name="driverSpeakingLanguageRadios"
                        [id]="'speaking-language-' + language.code" [value]="language.code"
                        [(ngModel)]="selectedSpeakingLanguage" />
                    <label class="form-check-label" [for]="'speaking-language-' + language.code">
                        {{ language.name }}
                    </label>
                </div>
            </div>
            }
        </div>
        } @if (countrySetting?.isAllowGenderSelection) {
        <div class="row mb-4">
            <div class="col-12 mb-3">
                <h5 class="mb-0">{{ "heading-title.gender-preference" | translate }}</h5>
            </div>
            <div class="col-12 mb-2">
                <div class="form-check form-check-secondary mb-0">
                    <input class="form-check-input" type="radio" name="genederPreferenceRadios"
                        id="geneder-preference-male" [value]="GenderOptions.MALE" [(ngModel)]="selectedGender" />
                    <label class="form-check-label" for="geneder-preference-male">
                        {{ "label-title.male" | translate }}
                    </label>
                </div>
            </div>
            <div class="col-12 mb-2">
                <div class="form-check form-check-secondary mb-0">
                    <input class="form-check-input" type="radio" name="genederPreferenceRadios"
                        id="geneder-preference-female" [value]="GenderOptions.FEMALE" [(ngModel)]="selectedGender" />
                    <label class="form-check-label" for="geneder-preference-female">
                        {{ "label-title.female" | translate }}
                    </label>
                </div>
            </div>
        </div>
        } @if (allowNoOfSeatSelection && vehicleCapacityList.length > 1) {
        <div class="row">
            <div class="col-12 mb-3">
                <h5 class="mb-0">{{ "heading-title.capacity-preference" | translate }}</h5>
            </div>
            @for (vehicleCapacity of vehicleCapacityList; track $index) {
            <div class="col-12 mb-2">
                <div class="form-check form-check-secondary mb-0">
                    <input class="form-check-input" type="radio" name="vehicleCapacityRadios"
                        [id]="'vehicleCapacity-' + vehicleCapacity" [value]="vehicleCapacity"
                        [(ngModel)]="selectedCapacity" />
                    <label class="form-check-label" [for]="'vehicleCapacity-' + vehicleCapacity">
                        {{ vehicleCapacity }}
                    </label>
                </div>
            </div>
            }
        </div>
        }
    </div>
    <div class="offcanvas-footer text-end border-top">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="clearFilter()">
            {{ "button-title.clear" | translate }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="applyFilter()">
            {{ "button-title.apply" | translate }}
        </button>
    </div>
</ng-template>